<template>
  <div class="mx-4 md:mx-0">
    <Cargando v-if="isLoading"></Cargando>
    <FormKit v-else-if="estaEditando" type="form" @submit="handleSubmit" v-model="valores">
      <h1 v-if="valores.titulo" class="titulo ml-0 pl-0">
        {{ valores.titulo }}
      </h1>
      <FormKitSchema :schema="computedFormSchema" />
      <template #submit>
        <div class="flex flex-col md:flex-row items-center justify-between text-sm text-gray-400 gap-3">
          <div>
            {{ submitText }}
          </div>
          <button type="submit"
            class="bg-black hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded w-full md:w-auto">
            Guardar
          </button>
        </div>
      </template>
    </FormKit>

    <div v-else>
      <div class="border-t border-gray-200 pt-4 cuento orsai-serif">
        <div class="tema border-white border py-1 rounded-full inline mb-2" v-if="propiedades.tema">
          {{ valores.tema }}
        </div>
        <h1 class="titulo">
          {{ valores.titulo }}
        </h1>
        <audio :src="valores.audio" v-if="propiedades.audio" controls class="w-full mb-4"></audio>

        <div class="resumen leading-snug" v-if="propiedades.resumen">
          {{ valores.resumen }}
        </div>
        <p class="contenido leading-tight mb-3" v-for="parrafo in valores.cuento.split('\n')" :key="parrafo"
          v-if="propiedades.cuento">
          {{ parrafo }}
        </p>
      </div>
      <div
        class="flex flex-col md:flex-row items-center text-sm text-gray-200 gap-3 border-t border-gray-300 mt-4 pt-4">
        <div v-if="!puedeEditar">
          <div class="text-sm text-gray-500 mb-2 md:mb-0">
            La edición de tu historia está cerrada, pero podrás seguir editándola en otra instancia.
          </div>
          <div class="text-sm font-semibold text-gray-800">
            ¡Nos vemos cada domingo a las 15 Hs!
          </div>
        </div>

        <div v-else>
          <div class="text-sm text-gray-500 mb-2 md:mb-0">
            {{ submitText }}
          </div>
        </div>

        <button type="submit" @click="estaEditando = true" v-if="puedeEditar"
          class="bg-black hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded w-full md:w-auto">
          Editar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import axios from "axios";
import { notify } from "notiwind";
import { miUsuario } from "@/services/usuarios";
import Cargando from "@/components/escuela/Cargando.vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useTalleresStore } from "@/stores/talleres";
const SERVER = "https://staging-strapi.orsai.org";

export default defineComponent({
  name: "CuentoForm",
  components: {
    Cargando,
  },
  props: {
    submitText: {
      type: String,
      default: "Podés cambiar, agregar y modificar tu historia todas las veces que quieras hasta el cierre del 1 de marzo. Y después podrás seguir.",
    },
    estado: {
      type: String,
      default: 'editar_todo',
      validator: (value) => {
        return ['cerrado', 'editar_cuerpo', 'editar_cuerpo_y_resumen', 'editar_audio', 'editar_todo'].includes(value)
      }
    }
  },
  setup(props) {
    const formSchema = ref([]);
    const valores = ref({ cuento: "" });
    const usuario = ref({});
    const isLoading = ref(true);
    const estaEditando = ref(false)
    const propiedades = ref({})
    const router = useRouter();

    // Computed property para determinar si se puede editar basado en el estado
    const puedeEditar = computed(() => {
      return props.estado !== 'cerrado'
    })



    // Computed properties para controlar qué campos son editables
    const camposEditables = computed(() => {
      const tieneValores = {
        titulo: !!valores.value.titulo,
        tema: !!valores.value.tema,
        resumen: !!valores.value.resumen,
        audio: !!valores.value.audio,
        cuento: !!valores.value.cuento
      }

      console.log('tieneValores', tieneValores)

      // Si tiene todos los datos, solo puede editar audio y cuento
      if (Object.values(tieneValores).every(Boolean)) {
        return {
          titulo: false,
          tema: false,
          resumen: true,
          audio: true,
          cuento: true,
        }
      }

      // Si no tiene todos los datos, puede editar todo
      return {
        titulo: true,
        tema: true,
        resumen: true,
        audio: true,
        cuento: true,
      }

      // return {
      //   // titulo: props.estado === 'editar_todo' || !tieneValores.titulo,
      //   titulo: false,
      //   tema: false,
      //   resumen: false,
      //   audio: true,
      //   cuento: true,
      //   // resumen: ['editar_todo', 'editar_cuerpo_y_resumen'].includes(props.estado) || !tieneValores.resumen,
      //   // audio: ['editar_todo', 'editar_audio'].includes(props.estado) || !tieneValores.audio,
      //   // cuento: ['editar_todo', 'editar_cuerpo', 'editar_cuerpo_y_resumen'].includes(props.estado) || !tieneValores.cuento
      // }
    })

    function maxWords(node, max = 50) {
      let s = node._value;
      if (s === undefined) return 0;
      if (s === null) return 0;
      s = s.replace(/(^\s*)|(\s*$)/gi, "");
      s = s.replace(/[ ]{2,}/gi, " ");
      s = s.replace(/\n /, "\n");
      return s.split(' ').filter(function (str) { return str != ""; }).length <= max;
    }

    const fetchCuentoUsuario = async () => {
      try {
        const res = await axios.get(`${SERVER}/api/cuentos?filters[idUsuario]=${usuario.value.id}&filters[taller]=dos`);
        const documentIdCuento = res.data.data[0]?.documentId;

        const response = await axios.get(`${SERVER}/api/cuentos/${documentIdCuento}?populate=*`);
        const dataCuento = response.data.data;
        // Reemplazar audio_v2 por audio
        if (dataCuento.audio_v2) {
          dataCuento.audio = dataCuento.audio_v2;
          delete dataCuento.audio_v2;
        }

        if (dataCuento) {
          valores.value = dataCuento;
        }
      } catch (error) {
        console.error("Error al obtener el cuento:", error);
      }
    };

    const fetchSchemaFromStrapi = async () => {
      try {
        const storeTaller = useTalleresStore();
        let schema = storeTaller.schema;
        if (!schema) {
          console.log("No hay schema en el store, obteniendo de Strapi");
          const response = await axios.get(`${SERVER}/api/content-type-builder/content-types`);
          schema = response.data.data.find((model) => model.uid === "api::cuento.cuento");
          console.log("schema", schema);
          storeTaller.setSchema(schema);
        }

        console.log("camposEditables", camposEditables);
        if (schema) {
          formSchema.value = Object.entries(schema.schema.attributes)
            .filter(([key]) => {
              console.log('key', key)
              // Solo incluir campos que sean editables según el estado actual
              return camposEditables.value[key]
            })
            .map(([key, value]) => {
              if (key === "audio") {
                return {
                  $formkit: "audio_orsai",
                  name: key,
                  label: "Audio de tu historia",
                  id_cuento: valores.value.documentId,
                  validation: "",

                };
              }
              if (value.type === "string") {
                return {
                  $formkit: "text",
                  name: key,
                  label: formatLabel(key),
                  validation: value.required ? "required" : "",
                };
              }
              if (value.type === "richtext" || value.type === "text") {
                const maxWordsRule = key === "cuento" ? "300" : "30";
                return {
                  $formkit: "wctextarea",
                  name: key,
                  label: formatLabel(key),
                  props: {
                    minHeight: key === "cuento" ? "20rem" : "",
                    maxWordsRule: maxWordsRule,
                  },
                  validationRules: { maxWords },
                  validation: value.required
                    ? "required|maxWords:" + maxWordsRule
                    : "maxWords:" + maxWordsRule,
                  validationMessages: {
                    maxWords:
                      "Solo puedes escribir hasta " +
                      maxWordsRule +
                      " palabras.",
                  },
                };
              }
              if (value.type === "enumeration") {
                value.enum.unshift({
                  value: null,
                  label: "-- Seleccioná una temática -- ",
                });

                return {
                  $formkit: "select",
                  name: key,
                  label: formatLabel(key),
                  options: value.enum,
                  validation: value.required ? "required" : "",
                };
              }
              return null;
            })
            .filter(Boolean)
            .sort((a, b) => {
              const order = ["titulo", "audio", "tema", "resumen", "cuento"];
              return order.indexOf(a.name) - order.indexOf(b.name);
            });
        }
      } catch (error) {
        console.error("Error al obtener el esquema:", error);
      }
    };

    const formatLabel = (key) => {
      const labels = {
        titulo: "Título de tu historia",
        tema: "¿A qué temática pertenece?",
        cuento: "Tu historia, en 300 palabras",
        audio: "Sube un audio",
      };
      return labels[key] || key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1");
    };

    const handleSubmit = async (data) => {
      console.log(data, valores.value);
      try {
        // Filtrar los datos según los campos editables o que tenia vacios
        let filteredData = Object.fromEntries(
          Object.entries(data).filter(([key]) => camposEditables.value[key] || true)
        );

        // Eliminar documentID, id, createdAt y updatedAt
        delete filteredData.documentId;
        delete filteredData.id;
        delete filteredData.createdAt;
        delete filteredData.updatedAt;


        // Renombrarar audio a audio_v2
        if (filteredData.audio) {
          filteredData.audio_v2 = filteredData.audio;
          delete filteredData.audio;
        }

        if (!usuario.value?.id) {
          notify({ group: "foo", title: "Error", type: "error", text: "No se pudo obtener tu usuario." });

          // Obtener el tallerSlug de la prop taller de la ruta
          const tallerSlug = useRoute().params.taller;
          router.push(`/ingresar?redirect=/escuela/hernan-casciari/${tallerSlug}/mi-anecdota`);

          return;
        }

        if (!valores.value.id) {
          const res = await axios.post(`${SERVER}/api/cuentos`, {
            data: {
              ...filteredData,
              idUsuario: usuario.value.id,
              taller: "dos",
            },
          });
          valores.value = res.data.data;
        } else {
          await axios.put(`${SERVER}/api/cuentos/${valores.value.documentId}`, {
            data: filteredData,
          });
        }

        // Cargar nuevamente el cuento
        await fetchCuentoUsuario();

        notify({ group: "foo", title: "¡Listo!", type: "success", text: "Tu historia se guardó correctamente." });
        estaEditando.value = false;
      } catch (error) {
        console.log("Error al guardar el cuento:", error);
        notify({ group: "foo", title: "Error", type: "error", text: "Hubo un error al guardar tu historia." });
      }
    };

    onMounted(async () => {
      usuario.value = await miUsuario();

      if (!usuario.value?.id) {
        const tallerSlug = useRoute().params.taller;
        router.push(`/ingresar?redirect=/escuela/hernan-casciari/${tallerSlug}/mi-anecdota`);
      }

      await fetchCuentoUsuario();
      await fetchSchemaFromStrapi();

      // Las propiedades son titulo, tema, resumen, audio y cuento
      propiedades.value = {
        titulo: !!valores.value.titulo,
        tema: !!valores.value.tema,
        resumen: !!valores.value.resumen,
        audio: !!valores.value.audio,
        cuento: !!valores.value.cuento
      }
      console.log('propiedades', valores.value)

      isLoading.value = false;
      const audio = computed(() => valores.value.audio);

      // Si NO tienen audio, cambiar a modo editar
      if (!audio.value) {
        estaEditando.value = true;
      }

      watch(audio, () => {
        if (audio.value) {
          handleSubmit(valores.value);
        }
      });
    });

    const computedFormSchema = computed(() => formSchema.value);



    return {
      valores,
      computedFormSchema,
      handleSubmit,
      isLoading,
      estaEditando,
      puedeEditar,
      propiedades
    };
  },
});
</script>

<style class="scss">
.orsai-serif {
  font-family: 'IBM Plex Serif', serif;
}

/* .formkit-label {
  @apply font-medium text-gray-700 mb-2;
  text-transform: none;
  font-size: 0.90rem !important;
} */

.cuento {
  .titulo {
    font-size: 2.5rem !important;
    font-weight: 300;
    padding-bottom: 1rem;
    margin-bottom: 0px;
    margin-top: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .resumen {
    font-size: 1.1rem !important;
    font-weight: 600;
    padding-bottom: 1rem;
  }

  .tema {
    font-size: 0.8rem !important;
    text-transform: uppercase;
  }

  .contenido {
    font-size: 1.2rem !important;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    .titulo {
      font-size: 1.8rem !important;
    }

    .resumen {
      font-size: 1rem !important;
    }

    .tema {
      font-size: 1rem !important;
    }

    .contenido {
      font-size: 1rem !important;
    }
  }
}
</style>